import React from 'react';

// import '@ant-design/compatible/assets/index.css';


import { Row, Col, Button } from 'antd';
import { connect } from 'react-redux'
import { ReactComponent as ImageOrTextIcon } from '../../resources/img/NewIcons/previewer/image_text.svg';
import { ReactComponent as InsvisibleSignatureIcon } from '../../resources/img/NewIcons/previewer/invisible-signature.svg';
import iconAlert from '../../resources/img/NewIcons/previewer/info.svg';
import { Typography } from 'antd';
import { getCustomColors } from '../Helpers/utils';


class SignatureInvisible extends React.Component {
  render() {
    return (
      <div style={{ padding: 10, marginBottom: 10, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <ImageOrTextIcon className='icon-menu' />
          <h2 className={'title'}>{this.props.title}</h2>
        </div>
        <div style={{ borderBottom: 'none', marginBottom: 10 }} />
        <Row gutter={16} className={'flexRight'} style={{ flex: 1 }}>
          <Col xs={24} md={15} style={{ textAlign: 'left', margin: 'auto' }}>
            <p style={{ marginTop: '10px', textAlign: 'justify' }} className={'mb-10'}>{this.props.text[0]}</p>
            <div style={{ display: 'flex', padding: 20, background: getCustomColors().colorPrimaryOpacity , borderRadius: 8 }}>
              <img src={iconAlert} alt='alert' />
              <div style={{ marginLeft: 20 }}>
                <Typography>{this.props.text[1]}</Typography>
              </div>
            </div>
            <p style={{ marginTop: '10px', textAlign: 'justify' }} className={'mb-10'}>{this.props.text[2]}</p>
          </Col>
          <Col xs={24} md={9} style={{ textAlign: 'center'}}>
            <InsvisibleSignatureIcon />
          </Col>
        </Row>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 'auto' }}>
          <Button type={'primary rounded-m'} onClick={this.props.modalDismiss}>
            {this.props.textButton}
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    language: state.auth.language,
  };
};

export default connect(mapStateToProps, {})(SignatureInvisible);
